module.exports = __webpack_public_path__ + "static/media/toggle-on.bdc08fd4.svg";